// What is left to refund on an order item or a journey trip passenger:
// its price minus what has been refunded so far.
function getRemainingRefundAmount(entity) {
  return (entity.price?.amount ?? 0) - (entity.cancelInformation?.amount?.amount ?? 0);
}

// Items listed in the special refund dialog. Fully refunded items are left out
// (a journey once all its passengers are), so they offer no refund amount input.
function getSpecialRefundableItems(items) {
  return items.filter((item) => {
    if (!item.isPaid) return false;

    if (item.type === "journey") {
      return item.itinerary?.some((trip) =>
        trip.passengers?.some((passenger) => getRemainingRefundAmount(passenger) > 0)
      );
    }

    const isListedType =
      ["railpass", "article", "taxi"].includes(item.type) ||
      (item.type === "distribution" && item.category == "physical") ||
      (item.type === "giftcard" && item.purpose == "purchasing");

    return isListedType && getRemainingRefundAmount(item) > 0;
  });
}

export { getRemainingRefundAmount, getSpecialRefundableItems };
